// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__oVl2d","shimmer":"Skeleton_shimmer__1vVT2","skeleton--circle":"Skeleton_skeleton--circle__6+7Q7","skeleton--card":"Skeleton_skeleton--card__y6YbR"};